<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14zJbFd/tc-custom/9783988260444.jpg?1704425338918" alt="This image is the cover for the book With Carson and Frémont, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">With Carson and Frémont, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: “BEING THE ADVENTURES, IN THE YEARS 1842–’43–’44, ON TRAIL OVER MOUNTAINS AND THROUGH DESERTS FROM THE EAST OF THE ROCKIES TO THE WEST OF THE SIERRAS, OF SCOUT CHRISTOPHER CARSON AND LIEUTENANT JOHN CHARLES FRÉMONT, LEADING THEIR BRAVE COMPANY INCLUDING THE BOY OLIVER".</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rheta Childe Dorr
      </h2>
      
      <p class="authorDescription body article">Rheta Louise Childe Dorr (1868–1948) was an American journalist, suffragist newspaper editor, writer, and political activist. Dorr is best remembered as one of the leading female muckraking journalists of the Progressive era and as the first editor of the influential newspaper, The Suffragist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78389168